import React from "react";
import './TextWithImageStyle.css';
// @ts-ignore
import classNames from 'classnames'

import ImageComponent from "../imageEconomicResearch/EconomicResearchImageComponent";
import {FlexedDiv, RowDiv} from "../styledComponents/CustomStyledComponents";
import './TextWithImageStyle.css'

interface Props {
    title: string,
    text: string,
    displayNumber: string,
    whiteBackground: boolean,
    id: string,
    inverted?: boolean,
    image?: string,
    imageStyle?: object,
    titlePivot: number
}

const SeparatorComponent: React.FC = () => {
    return (
        <React.Fragment>
            <FlexedDiv flexValue={0.25} />
            <FlexedDiv flexValue={0} style={{borderLeft: '4px solid #737373'}} />
            <FlexedDiv flexValue={0.25} />
        </React.Fragment>
    )
};

const TitleComponent: React.FC<{displayNumber: string, title: string, titlePivot: number}> = ({displayNumber, title, titlePivot}) => {
    const formattedText1 = title.split(' ').slice(0, titlePivot).join(' ');
    const formattedText2 = title.split(' ').slice(titlePivot, title.split(' ').length).join(' ');
    return(
        <RowDiv>
            <div className='textImageDisplayNumber'></div>
            <SeparatorComponent />
            <div className='textImageTitle'>
                {formattedText1}
                <br />
                {formattedText2}
            </div>
        </RowDiv>
    )
};

const TextComponent: React.FC<{text: string}> = ({children, text}) => {
    return (
        <RowDiv style={{marginTop: 30}}>
            <FlexedDiv flexValue={1.5} />
            <FlexedDiv flexValue={6} style={{paddingLeft: 5, fontFamily: 'AvenirNextLTPro-Regular'}}>
              { children }
            </FlexedDiv>
            <FlexedDiv flexValue={2} />
        </RowDiv>
    )
};

const TextWithImageComponent: React.FC<Props> = ({children, title, text, displayNumber, whiteBackground, id, inverted= false, imageStyle= {}, image= '', titlePivot }) => {
    const containerClasses = classNames('textWithImageContainer', { 'containerInverted': inverted }, {'section-white': whiteBackground});

    return (
        <div id={id} className={containerClasses}>
            <div className='imageContainer'>
                <ImageComponent image={image} imageStyle={imageStyle}/>
            </div>

            <div className={classNames('textContainer', { 'marginLeft150': inverted }) }>
                <TitleComponent displayNumber={displayNumber} title={title} titlePivot={titlePivot}/>
                <TextComponent text={text}>
                  { children }
                </TextComponent>
            </div>
        </div>
    );
};

export default TextWithImageComponent;
